<template>
	<v-layout row wrap fill-height class="customers">
		<v-flex xs3>
			<v-card>
				<v-list class="py-0 admin__sidebar-menu" dark>
					<v-list-tile ripple to="/admin/customers/import" avatar class="secondary">
						<v-list-tile-avatar>
							<div class="v-icon secondary theme--dark">
								<fa-icon :icon="['far', 'upload']" size="xs"/>
							</div>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title>Import Customers</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list>
					<v-list-tile>
						<v-text-field placeholder="Search" @input="updateSearch"></v-text-field>
					</v-list-tile>
				</v-list>

				<v-list subheader v-for="customer in filteredCustomers" :key="customer.id">
					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>{{customer.name}}</v-list-tile-title>
							<v-list-tile-sub-title v-if="customer.name !== customer.company">{{customer.company}}</v-list-tile-sub-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>
			</v-card>
		</v-flex>

		<v-flex lg9>
			<router-view :key="$route.fullPath"></router-view>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
	data() {
		return {
			search: "",
			customers: [],
		};
	},

	props: {
		slug: {
			default: null
		}
	},

	computed: {
		filteredCustomers() {
			return _.filter(this.customers, item => {
				return item.display.toLowerCase().indexOf(this.search) > -1;
			});
		}
	},

	methods: {
		...mapActions("quote-builder", {
			GET_CUSTOMERS: "getCustomers"
		}),

		updateSearch(value) {
			this.search = value;

			if(this.search.length >= 3 ) {
				this.getCustomers();
			}
		},

		getCustomers: _.debounce(function() {
			this.GET_CUSTOMERS({ search: this.search }).then(({data}) => {
				_.forEach(_.difference(data, this.customers, 'id'), (item) => {
					this.customers.push(item);
				})

				this.$nextTick(() => {
					this.$forceUpdate();
				});
			})
		}, 500)
	},

	created() {
		// this.GET_CUSTOMERS().then();
	}
};
</script>
